
import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";

import imagenBienvenida1 from "../:./../../assets/img/bienvenida/bienvenida_1.png";
import imagenBienvenida2 from "../:./../../assets/img/bienvenida/bienvenida_2.png";
import imagenBienvenida3 from "../:./../../assets/img/bienvenida/bienvenida_3.png";
import './styles/CarruselBienvenida.scss';
const CarruselBienvenida = () => {
  const settings = {
    dots: true, // Muestra indicadores de posición
    infinite: true, // Bucle infinito
    speed: 500, // Velocidad de transición
    slidesToShow: 1, // Muestra 1 elemento a la vez
    slidesToScroll: 1, // Desplaza 1 elemento a la vez
  };

  return (
    <div className="b-content-detalle">
      <Slider {...settings}>
        <div className="col-12 md:col-4 mb-2 b-detalle-block flex">
          <div className="detalle-block-img">
            <img src={imagenBienvenida1}></img>
          </div>
          <div className="detalle-block-detalle text-sm font-medium mt-2">
              En esta plataforma encontrarás los cursos y programas que hayas adquirido. Tendrás a tu
              disposición videos, materiales complementarios y ejercicios que nuestros docentes
              han diseñado para ti.
          </div>
        </div>

        <div className="col-12 md:col-4 mb-2 b-detalle-block flex">
          <div className="detalle-block-img">
            <img src={imagenBienvenida2}></img>
          </div>
          <div className="detalle-block-detalle text-sm font-medium mt-2">
              En tu recorrido académico encontrarás diversas evaluaciones que validarán todo
              lo que has aprendido hasta el momento. Tendrás 2 intentos en cada evaluación y 45
              minutos para contestar cada una.
          </div>
        </div>

        <div className="col-12 md:col-4 mb-2 b-detalle-block flex">
          <div className="detalle-block-img">
            <img src={imagenBienvenida3}></img>
          </div>
          <div className="detalle-block-detalle text-sm font-medium mt-2">
              Para complementar tu aprendizaje tendrás habilitado un chat donde
              podrás aclarar dudas acerca del contenido académico. Además tendrás acceso a
              nuestra biblioteca virtual.
          </div>
        </div>
      </Slider>
    </div>
  );
};

export default CarruselBienvenida;
